/**
 * Avalara © 2017
 * file: engines/opus_ui/src/Users.js
 */

import React, { Component } from 'react';
import './Users.css';

class Users extends Component {
  render() {
    /*
      "id": 30577,
      "accountId": 1987654323,
      "companyId": 0,
      "userName": "devadmin@avalara.com",
      "firstName": "Dev",
      "lastName": "Admin",
      "email": "ryan.malgren@avalara.com",
      "postalCode": "98110",
      "securityRoleId": "AccountAdmin",
      "passwordStatus": "UserCannotChange",
      "isActive": true,
      "createdDate": "2013-06-12T22:07:51.39",
      "createdUserId": 0,
      "modifiedDate": "2017-03-20T13:02:38.5",
      "modifiedUserId": 0
    */
    if (this.props.data) {
      let users = this.props.data.map((user) => {
        return (
          <tr>
            <td>{user.securityRoleId}</td>
            <td>{`${user.firstName} ${user.lastName}`}</td>
            <td>{user.userName}</td>
            <td>{user.email}</td>
            <td>
              {new Date(user.createdDate).toLocaleDateString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
              })}
            </td>
          </tr>
        );
      });

      return (
        <table>
          <thead>
            <tr>
              <td>Role</td>
              <td>Name</td>
              <td>Username</td>
              <td>Email</td>
              <td>Created Date</td>
            </tr>
          </thead>
          <tbody>{users}</tbody>
        </table>
      );
    } else {
      return false;
    }
  }
}

export default Users;
